import Splide from '@splidejs/splide';

// init carousels
Splide.defaults = {
	type   : 'loop',
	speed: 800,
	//easing: 'cubic-bezier(.12,.96,.51,.99)',
	lazyLoad : 'nearby',
	direction: 'ttb',
	perPage: 1,
	wheel: true,
	waitForTransition: true,
	wheelMinThreshold: 33,
	perMove: 1,
	height: '100vh',
	arrowPath: 'M24 36c-.6 0-1-.2-1.4-.6-.4-.4-.6-.8-.6-1.4 0-.6.2-1 .6-1.4L33.2 22H2c-.6 0-1-.2-1.4-.6C.2 21 0 20.6 0 20s.2-1 .6-1.4c.4-.4.8-.6 1.4-.6h31.2L22.6 7.4C22.2 7 22 6.6 22 6c0-.6.2-1 .6-1.4.4-.4.8-.6 1.4-.6.6 0 1 .2 1.4.6l14 14c.4.4.6.9.6 1.4 0 .5-.2 1-.6 1.4l-14 14c-.4.4-.8.6-1.4.6z'
}

window.addEventListener('load', () => {
	const splide = new Splide( '.splide' );
   splide.mount();

	splide.on( 'move', function () {
		player.pause();
		console.log('moved');
	});

	window.addEventListener('keydown', function(event) {
		const key = event.key; // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"

		switch (event.key) {
			case "ArrowUp":
				 // Left pressed
				 splide.go('<')
				 break;
			case "ArrowDown":
				 // Right pressed
				 splide.go('>')
				 break;
	  }
	});

})

const btnFullscreen = document.getElementById('btnFullscreen');

btnFullscreen.addEventListener('click', () => {
	toggleFullScreen();
})

function toggleFullScreen() {
	btnFullscreen.classList.toggle('on');
	if (!document.fullscreenElement) {
		document.documentElement.requestFullscreen();
	} else if (document.exitFullscreen) {
		document.exitFullscreen();
	}
}

const iframe = document.getElementById('video');
const player = new Vimeo.Player(iframe);
const btnPlayVideo = document.getElementById('btnPlayVideo');
const videoOverlay = document.getElementById('videoOverlay');

btnPlayVideo.addEventListener('click', () => {
	videoOverlay.classList.add('hide')
	player.play();
})


player.on('play', function() {
	//console.log('played the video!');
});

player.getVideoTitle().then(function(title) {
	//console.log('title:', title);
});


